// 克罗地亚语
import hrLocale from 'element-ui/lib/locale/lang/hr'


const hr = {
  // ============== 登陆页 start=============
  "登录": "Prijava",
  "退出": "Odjava",
  "账号": "Račun",
  "密码": "Lozinka",
  "验证码": "Verifikacijski kod",
  "请输入账号": "Molimo unesite svoj račun",
  "请输入密码": "Molimo unesite lozinku",
  "请输入验证码": "Molimo unesite verifikacijski kod",
  "验证码不正确": "Netočan verifikacijski kod",
  "没有账号": "Nema računa",
  "请": "Molimo",
  "点击注册": "Kliknite za registraciju",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Ukupan broj trgovina",
  "用户总量": "Ukupan broj korisnika",
  "营业总量": "Ukupni prihod od poslovanja",
  "订单总量": "Ukupni broj narudžbi",
  "商品总量": "Ukupan broj inventara",
  "销售总额": "Ukupna prodaja",
  "元": "€",
  "预计收入": "Procijenjeni prihod",
  "今日概况": "Današnji pregled",
  "销售额": "Volumen prodaje",
  "支付订单数": "Plaćene narudžbe",
  "昨日": "Jučer",
  "新增用户数": "Novi korisnici",
  "新增商户": "Novi trgovci",
  "下单用户数": "Korisnici koji stavljaju narudžbe",
  "待办事项": "Nadolazeći zadaci",
  "请尽快处理，以免影响营业": "Molimo odmah se pozabavite time kako biste spriječili utjecaj na poslovanje",
  "待处理订单": "Narudžbe u obradi",
  "库存告急": "Hitno upozorenje na inventar",
  "商品排行榜": "Top lista proizvoda",
  "销量": "Volumen prodaje",
  "暂无上榜记录": "Trenutno nema zabilježenih pozicija",
  "成交额": "Volumen transakcija",
  "成交量": "Broj transakcija",
  "退单额": "Ukupni iznos povrata",
  "退单量": "Broj povrata narudžbi",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Osnovne informacije",
  "编辑门店": "Uredi trgovinu",
  "官方网站": "Službena web stranica",
  "门店服务": "Usluge trgovine",
  "服务与营业时间": "Usluge i radno vrijeme",
  "桌码管理": "Upravljanje brojevima stolova",
  "收银台": "Blagajna",
  "后厨": "Kuhinja",
  "商品": "Roba",
  "添加商品": "Dodaj robu",
  "网站": "Web stranica",
  "网站编辑": "Uređivanje web stranice",
  "资讯": "Informacije",
  "上一步": "Prethodni korak",
  "保存": "Spremi",
  "下一步": "Sljedeći korak",
  "提交失败": "Neuspjela predaja",
  "获取当前进度信息失败": "Neuspjelo dobivanje trenutnih informacija o napretku",
  "门店名称": "Naziv trgovine",
  "请输入门店名称": "Molimo unesite naziv trgovine",
  "登录密码": "Lozinka za prijavu",
  "请输入登录密码": "Molimo unesite lozinku za prijavu",
  "确认密码": "Potvrdi lozinku",
  "请输入确认密码": "Molimo potvrdite lozinku",
  "联系人": "Kontakt",
  "请输入联系人": "Molimo unesite ime kontakta",
  "请输入联系电话": "Molimo unesite broj telefona kontakta",
  "店铺类型": "Vrsta trgovine",
  "分店": "Podružnica",
  "直营": "Direktna prodaja",
  "商品分类": "Klasifikacija robe",
  "同步主店": "Sinkronizacija s glavnom trgovinom",
  "分店创建": "Stvaranje podružnice",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Srdačan podsjetnik: Nakon odabira, molimo ne mijenjajte nasumično kako biste izbjegli zbunjenost podacima o proizvodima trgovine",
  "绑定用户": "Poveži korisnika",
  "选择用户": "Odaberi korisnika",
  "用户昵称": "Nadimak",
  "选择图片": "Odaberi sliku",
  "地址": "Adresa",
  "请输入地址": "Molimo unesite adresu",
  "门店坐标": "Koordinate trgovine",
  "商家介绍": "Uvod trgovca",
  "状态": "Status",
  "开启": "Otvara",
  "禁止": "Zatvara",
  "营业状态": "Status poslovanja",
  "营业中": "Otvoreno",
  "停止营业": "Zatvoreno",
  "上传图片": "Prenesi sliku",
  "获取当前门店失败，请刷新界面重试": "Neuspjelo dobivanje trenutne trgovine, molimo osvježite stranicu i pokušajte ponovno",
  "商城设置": "Postavke trgovine",
  "商城名称": "Naziv trgovine",
  "商城名称不能为空": "Naziv trgovine ne smije biti prazan",
  "访问网址后缀": "Sufiks za pristup URL-u",
  "访问网址": "Posjeti URL",
  "手机网站": "Mobilna web stranica",
  "默认": "Zadano",
  "自定义": "Prilagođeno",
  "Pad点餐网站": "Web stranica za naručivanje preko tableta",
  "收银台网站": "Web stranica blagajne",
  "后厨网站": "Web stranica kuhinje",
  "会员设置": "Postavke članstva",
  "请选择默认头像": "Molimo odaberite zadani avatar",
  "门店二维码": "QR kôd trgovine",
  "下载": "Preuzmi",
  "营业时间": "Radno vrijeme",
  "店内营业时间": "Radno vrijeme u trgovini",
  "请选择店内营业时间": "Molimo odaberite radno vrijeme u trgovini",
  "开始时间": "Vrijeme početka",
  "结束时间": "Vrijeme završetka",
  "至": "Do",
  "选择时间范围": "Odaberite vremenski raspon",
  "自提营业时间": "Radno vrijeme preuzimanja",
  "请选择自提营业时间": "Molimo odaberite radno vrijeme preuzimanja",
  "外卖营业时间": "Radno vrijeme dostave hrane",
  "请选择外卖营业时间": "Molimo odaberite radno vrijeme dostave hrane",
  "外卖配送": "Dostava hrane",
  "注": "Napomena",
  "外卖配送方式至少选择一个": "Morate odabrati barem jedan način dostave hrane",
  "店内配置": "Konfiguracija u trgovini",
  "店内用餐方式至少选择一个": "Morate odabrati barem jedan način konzumacije u trgovini",
  "堂食服务": "Usluga konzumacije u restoranu",
  "店内堂食结算模式": "Način plaćanja u restoranu",
  "先结账后用餐": "Platite prije jela",
  "先用餐后结账": "Jedite prije plaćanja",
  "收银台桌台清台设置": "Postavke čišćenja stolova blagajne",
  "定时清台": "Planirano čišćenje stolova",
  "立即清台": "Odmah čišćenje stolova",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Nakon uključivanja planiranog čišćenja stolova, sustav će samostalno očistiti stolove blagajne za naručivanje nakon postavljenog vremena. Ova funkcija funkcionira samo u načinu plaćanja prije obroka",
  "桌台订单清台设置": "Postavke čišćenja stolova",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Automatsko čišćenje stolova nakon minuta (vrijeme čišćenja stolova za naručivanje skeniranjem kodova stolova i vremena za čišćenje stolova blagajne)",
  "店内堂食服务费": "Naknada za uslugu konzumacije u trgovini",
  "按就餐人数收取": "Naplatiti prema broju gostiju",
  "按每桌台收取": "Naplatiti po stolu",
  "请输入服务费": "Molimo unesite naknadu za uslugu",
  "位": "Sjedalo",
  "桌": "Stol",
  "店内包装费类型": "Vrsta naknade za pakiranje u trgovini",
  "按商品收费": "Naplatiti prema proizvodu",
  "按单收费": "Naplatiti po narudžbi",
  "包装费": "Naknada za pakiranje",
  "请输入包装费": "Molimo unesite naknadu za pakiranje",
  "外卖服务": "Usluga dostave hrane",
  "外卖包装费类型": "Vrsta naknade za pakiranje kod dostave hrane",
  "外卖配送范围": "Opseg dostave hrane",
  "请输入外卖配送范围": "Molimo unesite opseg dostave hrane",
  "外卖配送费": "Naknada za dostavu hrane",
  "请输入外卖配送费": "Molimo unesite naknadu za dostavu hrane",
  "最低消费": "Minimalna potrošnja",
  "请输入最低消费": "Molimo unesite minimalnu potrošnju",
  "添加类型": "Dodaj tip",
  "排序": "Sortiranje",
  "类型名称": "Naziv tipa",
  "操作": "Operacija",
  "删除": "Izbriši",
  "桌位管理": "Upravljanje stolovima",
  "最少人数": "Minimalan broj osoba",
  "最多人数": "Maksimalan broj osoba",
  "取 消": "Poništi",
  "确 定": "Potvrdi",
  "请输入类型名称": "Molimo unesite naziv tipa",
  "排序不能为空": "Sortiranje ne smije biti prazno",
  "排序必须为数字": "Sortiranje mora biti broj",
  "添加成功": "Uspješno dodano",
  "修改类型": "Uredi tip",
  "修改成功": "Uspješno izmijenjeno",
  "添加区域": "Dodaj područje",
  "区域名称": "Naziv područja",
  "修改区域": "Uredi područje",
  "请输入区域名称": "Molimo unesite naziv područja",
  "分类名称": "Naziv kategorije",
  "编号": "Broj",
  "选择区域": "Odaberite područje",
  "请选择": "Molimo odaberite",
  "选择类型": "Odaberite tip",
  "查询": "Pretraži",
  "桌号id": "ID stola",
  "所属区域": "Pripadajuće područje",
  "桌位类型": "Tip stola",
  "桌位编码": "Kod stola",
  "人数区间": "Raspon broja osoba",
  "人": "Osoba",
  "二维码": "QR kod",
  "桌位编号": "Broj stola",
  "请输入桌位编号": "Molimo unesite broj stola",
  "请选择类型名称": "Odaberite naziv tipa",
  "请选择所属区域": "Odaberite pripadajuće područje",
  "添加桌位": "Dodaj stol",
  "关键词": "Ključna riječ",
  "添加收银员": "Dodaj blagajnika",
  "姓名": "Ime",
  "登录账号": "Korisničko ime za prijavu",
  "联系方式": "Kontakt metoda",
  "收银员管理": "Upravljanje blagajnicima",
  "编辑": "Uredi",
  "手机号": "Broj mobitela",
  "请输入登录账号": "Molimo unesite korisničko ime za prijavu",
  "长度在6到16个字符": "Duljina od 6 do 16 znakova",
  "两次输入密码不一致！": "Dvaput unesena lozinka nije ista!",
  "禁用": "Onemogućiti",
  "删除后不可恢复，确认删除该记录吗?": "Nakon brisanja ne može se vratiti, potvrđujete li brisanje ovog zapisa?",
  "提示": "Savjet",
  "后厨人员管理": "Upravljanje kuhinjskim osobljem",
  "添加后厨人员": "Dodaj kuhinjsko osoblje",
  "添加后厨账号": "Dodaj kuhinjski račun",
  "普通分类": "Standardna klasifikacija",
  "添加分类": "Dodaj kategoriju",
  "图片": "Slika",
  "分类排序": "Sortiranje kategorija",
  "税率设置": "Postavke poreza",
  "添加税率": "Dodaj poreznu stopu",
  "税率分类名称": "Naziv kategorije poreza",
  "税率": "Porezna stopa",
  "适用于菜品分类": "Primjenjivo na klasifikaciju jela",
  "未找到相应数据": "Nisu pronađeni odgovarajući podaci",
  "请输入分类名称": "Molimo unesite naziv kategorije",
  "分类排序不能为空": "Sortiranje kategorija ne smije biti prazno",
  "分类排序必须为数字": "Sortiranje kategorija mora biti broj",
  "正在翻译，请稍后": "Prijevod u tijeku, pričekajte",
  "多语言翻译": "Višejezični prijevod",
  "修改分类": "Uredi kategoriju",
  "翻译": "Prijevod",
  "分类图片": "Slika kategorije",
  "外卖商品": "Dostava hrane",
  "店内商品": "Proizvodi trgovine",
  "商品管理": "Upravljanje proizvodima",
  "分类管理": "Upravljanje kategorijama",
  "上架中": "Na raspolaganju",
  "下架": "Van ponude",
  "商品名称": "Naziv proizvoda",
  "请输入商品名称": "Molimo unesite naziv proizvoda",
  "添加产品": "Dodaj proizvod",
  "全部": "Sve",
  "产品": "Proizvod",
  "实际销量": "Stvarna prodaja",
  "库存": "Zaliha",
  "发布时间": "Vrijeme objave",
  "销售价": "Prodajna cijena",
  "下架中": "Van ponude",
  "重新上架": "Ponovno na policu",
  "上架": "Na polici",
  "确认要": "Potvrda za",
  "成功": "Uspjeh",
  "删除成功": "Uspješno izbrisano",
  "请先选择一个选项": "Molimo prvo odaberite opciju",
  "正在完成翻译，请稍后操作": "Završavam prijevod, molim vas pričekajte",
  "请检查表单的必填项是否全部填写": "Molimo provjerite jesu li svi obavezni dijelovi obrasca popunjeni",
  "补全成功": "Uspješno dovršeno",
  "主语言选择": "Odabir glavnog jezika",
  "请选择主语言": "Molimo odaberite glavni jezik",
  "高级设置": "Napredne postavke",
  "取消": "Odustani",
  "修改": "Uredi",
  "保存成功": "Uspješno spremljeno",
  "规格": "Specifikacija",
  "库存计算方式": "Metoda računanja zaliha",
  "下单减库存": "Narudžba za smanjenje zaliha",
  "特色分类": "Istaknuta klasifikacija",
  "产品规格": "Specifikacija proizvoda",
  "单规格": "Jedna specifikacija",
  "多规格": "Višestruke specifikacije",
  "此商品正在参加活动，不能修改规格": "Ovaj proizvod sudjeluje u aktivnosti i ne možete mijenjati specifikaciju",
  "AI魔法创建": "AI Čarolija Kreacija",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Kroz tehnologiju umjetne inteligencije, možete automatski popuniti detalje o proizvodu na temelju naziva proizvoda, kao što su sastojci, prodajne točke, okusi itd.",
  "所属分类": "Pripadajuća kategorija",
  "请选择商品分类": "Molimo odaberite kategoriju proizvoda",
  "请填写商品详情": "Molimo unesite detalje o proizvodu",
  "商品详情": "Detalji proizvoda",
  "换一换": "Promijeni",
  "产品价格": "Cijena proizvoda",
  "请填写产品价格": "Molimo unesite cijenu proizvoda",
  "请填写包装费": "Molimo unesite naknadu za pakiranje",
  "规格明细": "Detalji specifikacije",
  "规格名称": "Naziv specifikacije",
  "请输入内容": "Molimo unesite sadržaj",
  "价格": "Cijena",
  "添加规格": "Dodaj specifikaciju",
  "商品图片": "Slika proizvoda",
  "请上传商品图片": "Molimo prenesite sliku proizvoda",
  "从AI图库中选择": "Odaberite iz AI knjižnice slika",
  "使用中文从AI图库搜索": "Koristite kineski jezik za pretraživanje u AI knjižnici slika",
  "AI图库": "AI knjižnica slika",
  "确认使用": "Potvrdi korištenje",
  "AI未识别到您的商品图片": "AI nije prepoznao sliku vašeg proizvoda",
  "可在搜索框": "Dostupno u pretraživaču",
  "更换菜品名称": "Promijenite naziv jela",
  "请输入菜品名称！": "Molimo unesite naziv jela!",
  "请在主语言界面上进行操作": "Molimo obavite operaciju na glavnom jezičnom sučelju",
  "本商品正在参加活动，不能删除规格！": "Ovaj proizvod sudjeluje u aktivnosti i ne možete brisati specifikacije!",
  "不能再删除了": "Ne može se više izbrisati",
  "多语言": "Višejezično",
  "商品加料": "Dodaci za proizvod",
  "添加加料": "Dodaj dodatke",
  "加料名称": "Naziv dodatka",
  "如:杯型": "Kao: Vrsta čaše",
  "内容": "Sadržaj",
  "积分设置": "Postavke bodova",
  "是否开启积分赠送": "Želite li omogućiti darivanje bodova",
  "关闭": "Zatvori",
  "其他设置": "Ostale postavke",
  "商品状态": "Status proizvoda",
  "选择商品状态": "Odaberite status proizvoda",
  "初始销量": "Početna prodaja",
  "商品排序": "Poredak proizvoda",
  "限购数量": "Ograničenje kupnje",
  "每个会员购买的最大数量，0为不限购": "Maksimalni broj koji svaki član može kupiti, 0 znači bez ograničenja",
  "会员折扣设置": "Postavke popusta za članove",
  "是否开启会员折扣": "Želite li omogućiti popust za članova",
  "默认折扣": "Zadani popust",
  "单独设置折扣": "Postavljanje popusta zasebno",
  "默认折扣：默认为用户所属会员等级的折扣率": "Zadani popust: Zadano je stopa popusta razine članstva korisnika",
  "折扣佣金类型": "Vrsta popusta",
  "百分比": "Postotak",
  "固定金额": "Fiksni iznos",
  "会员等级": "Razina članstva",
  "折扣": "Popust",
  "请输入折扣": "Molimo unesite popust",
  "分销设置": "Postavke distribucije",
  "是否开启分销": "Želite li omogućiti distribuciju",
  "分销规则": "Pravila distribucije",
  "平台规则": "Pravila platforme",
  "单独规则": "Zasebno pravilo",
  "平台规则：层级": "Pravila platforme: Razina",
  "1级佣金": "Provizija 1. razine",
  "2级佣金": "Provizija 2. razine",
  "3级佣金": "Provizija 3. razine",
  "分销佣金类型": "Vrsta provizije za distribuciju",
  "单独分销设置": "Zasebne postavke distribucije",
  "一级佣金": "Provizija 1. razine",
  "二级佣金": "Provizija 2. razine",
  "三级佣金": "Provizija 3. razine",
  "请填写商品名称": "Molimo unesite naziv proizvoda",
  "你选择商品分类": "Odabrali ste kategoriju proizvoda",
  "商品卖点": "Prodajne točke proizvoda",
  "配料": "Sastojci",
  "添加项": "Dodaj stavku",
  "删除项": "Obriši stavku",
  "审核状态": "Status provjere",
  "选择审核状态": "Odaberite status provjere",
  "通过": "Prođi",
  "未通过": "Nije prošlo",
  "审核备注": "Komentar provjere",
  "请输入拒绝原因": "Molimo unesite razlog odbijanja",
  "商品属性": "Atributi proizvoda",
  "添加属性": "Dodaj atribute",
  "属性名称": "Naziv atributa",
  "属性值": "Vrijednost atributa",
  "至少填写两个": "Najmanje dvije stavke",
  "如:温度": "Primjer: Temperatura",
  "口味": "Okus",
  "商品同步": "Sinkronizacija proizvoda",
  "同步至外卖": "Sinkroniziraj na dostavu",
  "是": "Da",
  "否": "Ne",
  "库存数量": "Količina zaliha",
  "请填写库存数量": "Molimo unesite količinu zaliha",
  "请上传分类图片": "Molimo prenesite sliku kategorije",
  "发布": "Objavi",
  "级": "Razred",
  "请填写口味": "Molimo unesite okus",
  "从AI图库搜索": "Pretražite u AI knjižnici slika",
  "AI获取标签": "AI dobiva oznake",
  "标签": "Oznaka",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Dodane oznake mogu pomoći AI pomoćniku za naručivanje da preciznije razumije potrebe kupca",
  "同步至店内": "Sinkroniziraj u trgovinu",
  "是否同步商品至外卖": "Želite li sinkronizirati proizvode na dostavu",
  "是否同步商品至店内": "Želite li sinkronizirati proizvode u trgovinu",
  "付款减库存": "Plaćanje za smanjenje zalihe",
  "菜品录入使用语言": "Jezik koji se koristi za unos jela",
  "网站主页": "Početna stranica web mjesta",
  "主题编辑": "Uređivanje teme",
  "我的菜单": "Moj meni",
  "添加菜单": "Dodaj meni",
  "菜单名称": "Naziv menija",
  "图标": "Ikona",
  "是否显示": "Prikazati",
  "添加时间": "Vrijeme dodavanja",
  "更新时间": "Vrijeme ažuriranja",
  "正在处理": "Obrada",
  "处理失败，请重试": "Obrada nije uspjela, molimo pokušajte ponovo",
  "此操作将永久删除该记录, 是否继续?": "Ova će radnja trajno izbrisati ovaj zapis, želite li nastaviti?",
  "确定": "Potvrdi",
  "主题选择": "Odabir teme",
  "主题一": "Tema Jedan",
  "主题二": "Tema Dva",
  "主题三": "Tema Tri",
  "主题四": "Tema Četiri",
  "主题五": "Tema Pet",
  "主题六": "Tema Šest",
  "主页预览": "Pregled početne stranice",
  "撤回": "Povuci",
  "获取预览网站失败,请检查网络或联系管理员": "Neuspješno dobivanje pretpregleda web mjesta, molimo provjerite mrežu ili kontaktirajte administratora",
  "撤回成功": "Uspješno povučeno",
  "编辑菜单": "Uredite meni",
  "请输入广告标题": "Molimo unesite naziv oglasa",
  "图标大小为": "Veličina ikone je",
  "显示": "Prikaz",
  "隐藏": "Skrivanje",
  "请输入数字": "Molimo unesite broj",
  "链接": "Poveznica",
  "选择链接": "Odaberite poveznicu",
  "提交": "Podnesi",
  "请输入菜单名称": "Molimo unesite naziv menija",
  "链接到": "Povezan s",
  "请上传图标": "Molimo prenesite ikonu",
  "确定要删除吗?": "Želite li zaista izbrisati?",
  "次浏览": "Pregledano puta",
  "每日必拼": "Dnevna opcija",
  "更多": "Više",
  "2人团": "Dvije osobe",
  "去开团": "Pokreni grupu",
  "活动砍价": "Pregovor o cijeni",
  "已抢2件": "Već ugrabljeno 2 komada",
  "立即砍价": "Odmah pregovarajte",
  "满": "Popunjen",
  "可用": "Dostupno",
  "立即领取": "Odmah preuzmite",
  "热门直播": "Popularni prijenos uživo",
  "已售": "Prodano",
  "限时秒杀": "Ograničeno vrijeme za ubojstvo sekundi",
  "搜索商品": "Pretraži proizvode",
  "线下门店": "Trgovina izvan mreže",
  "门店logo": "Logo trgovine",
  "门店地址": "Adresa trgovine",
  "联系电话": "Kontaktni broj",
  "您的浏览器不支持 video 标签": "Vaš preglednik ne podržava oznaku video",
  "店家正在直播、折扣套餐秒杀中": "Vlasnik trgovine trenutno je uživo, u procesu sekundarnog sniženja cijena paketa",
  "进入": "Uđi",
  "至少保留一个": "Zadržite barem jedan",
  "咨询分类": "Kategorija savjetovanja",
  "全部分类": "Sve kategorije",
  "显示数量": "Prikaži količinu",
  "咨询数据请到": "Podaci o savjetovanju potražite na",
  "插件": "Dodatak",
  "显示类型": "Vrsta prikaza",
  "有图模式": "Način sa slikom",
  "无图模式": "Način bez slika",
  "组件样式": "Stil komponente",
  "显示内容": "Prikaži sadržaj",
  "拼团价格": "Cijena grupne kupovine",
  "划线价格": "Cijena s crtom",
  "指示点颜色": "Boja pokazivača",
  "重置": "Poništi",
  "切换时间": "Promjena vremena",
  "轮播图自动切换的间隔时间，单位：毫秒": "Vrijeme između automatskih promjena slika u slideru, u milisekundama",
  "建议尺寸": "Preporučena veličina",
  "链接地址": "Poveznica",
  "请选择链接地址": "Molimo odaberite poveznicu",
  "添加一个": "Dodaj jedan",
  "标题内容": "Sadržaj naslova",
  "文字内容": "Tekstualni sadržaj",
  "链接名称": "Naziv poveznice",
  "正在砍价": "Pregovaramo",
  "商品原价": "Originalna cijena proizvoda",
  "背景颜色": "Boja pozadine",
  "组件高度": "Visina komponente",
  "上下边距": "Gornja i donja margina",
  "线条样式": "Stil linije",
  "实线": "Puna linija",
  "虚线": "Isprekidana linija",
  "点状": "Točkasta linija",
  "线条颜色": "Boja linije",
  "线条高度": "Visina linije",
  "左右边距": "Lijeva i desna margina",
  "标题": "Naslov",
  "颜色": "Boja",
  "每行数量": "Broj stavki po retku",
  "1个": "1 komad",
  "2个": "2 komada",
  "文字颜色": "Boja teksta",
  "公告图标": "Ikona obavijesti",
  "公告内容": "Sadržaj obavijesti",
  "商品来源": "Izvor proizvoda",
  "自动获取": "Automatsko dobivanje",
  "手动选择": "Ručni odabir",
  "综合": "Sveobuhvatno",
  "商品列表": "Popis proizvoda",
  "选择产品": "Odaberite proizvod",
  "列表平铺": "Pločice popisa",
  "横向滑动": "Horizontalno klizanje",
  "分列数量": "Broj stupaca",
  "单列": "Jedan stupac",
  "两列": "Dva stupca",
  "三列": "Tri stupca",
  "商品价格": "Cijena proizvoda",
  "商品销量": "Prodaja proizvoda",
  "提示文字": "Tekst poruke",
  "搜索框样式": "Stil okvira za pretraživanje",
  "方形": "Kvadratni",
  "圆角": "Zaobljeni rub",
  "圆弧": "Luk",
  "文字对齐": "Poravnanje teksta",
  "居左": "Lijevo",
  "居中": "Centrirano",
  "居右": "Desno",
  "秒杀价格": "Cijena za brzo prodavanje",
  "底边距": "Donji rub",
  "右边距": "Desni rub",
  "不透明度": "Neprozirnost",
  "客服类型": "Tip korisničke podrške",
  "在线聊天": "Online razgovor",
  "拨打电话": "Poziv",
  "电话号码": "Broj telefona",
  "客服图标": "Ikona korisničke podrške",
  "标题类型": "Vrsta naslova",
  "页面名称": "Naziv stranice",
  "页面名称仅用于后台查找": "Naziv stranice se koristi samo za pretragu u pozadini",
  "分享标题": "Naslov za dijeljenje",
  "小程序端转发时显示的标题": "Naslov koji se prikazuje prilikom dijeljenja putem mini programa",
  "文章分类": "Kategorija članaka",
  "文章数据请到": "Podatke o člancima potražite na",
  "内容管理": "Upravljanje sadržajem",
  "文章列表": "Popis članaka",
  "中管理": "Upravljajte unutar",
  "单行": "Jedan red",
  "两行": "Dva reda",
  "门店列表": "Popis trgovina",
  "选择门店": "Odaberite trgovinu",
  "展示数量": "Broj prikaza",
  "视频高度": "Visina videa",
  "滑块可用左右方向键精确调整": "Klizač se može precizno podesiti lijevom i desnom tipkom sa strelicom",
  "视频封面": "Naslovnica videa",
  "视频地址": "Adresa videa",
  "自动播放": "Automatsko reproduciranje",
  "布局方式": "Metoda rasporeda",
  "堆积两列": "2 složene kolone",
  "堆积三列": "3 složene kolone",
  "堆积四列": "4 složene kolone",
  "橱窗样式": "Stil izloga",
  "橱窗样式最多显示四张图片，超出隐藏": "Stil izloga prikazuje najviše četiri slike, skriva se ako ih ima više",
  "请确保所有图片的尺寸/比例相同": "Molimo osigurajte da sve slike imaju iste dimenzije/proporcije",
  "标题文字": "Tekst naslova",
  "组件库": "Biblioteka komponenti",
  "媒体组件": "Medijska komponenta",
  "商城组件": "Komponenta trgovine",
  "工具组件": "Alatna komponenta",
  "登录组件": "Komponenta za prijavu",
  "资讯管理": "Upravljanje informacijama",
  "添加资讯": "Dodaj informaciju",
  "资讯ID": "ID informacija",
  "封面": "Naslovnica",
  "资讯标题": "Naslov informacije",
  "虚拟阅读量": "Virtualna količina čitanja",
  "实际阅读量": "Stvarna količina čitanja",
  "资讯排序": "Poredak informacija",
  "已取消删除": "Otkazano brisanje",
  "请输入文章标题": "Molimo unesite naslov članka",
  "描述": "Opis",
  "请输入文章描述": "Molimo unesite opis članka",
  "缩略图": "Skraćeni prikaz",
  "资讯分类": "Kategorija informacija",
  "资讯状态": "Status informacije",
  "资讯内容": "Sadržaj informacija",
  "分类ID": "ID kategorije",
  "编辑分类": "Uredi kategoriju",
  "恭喜你，修改成功": "Čestitamo, uspješno ste izmijenili",
  "编辑资讯": "Uredi informaciju",
  "份": "Porcija",
  "中文": "Kineski",
  "英语": "Engleski",
  "意大利语": "Talijanski",
  "德语": "Njemački",
  "西班牙语": "Španjolski",
  "法语": "Francuski",
  "克罗地亚": "Hrvatski",
  "斯洛文尼亚": "Slovenski",
  "匈牙利语": "Mađarski",
  "规格库": "Biblioteka specifikacija",
  "属性库": "Biblioteka atributa",
  "加料库": "Biblioteka dodataka",
  "规格名": "Naziv specifikacije",
  "批量删除": "Masa brisanje",
  "请输入规格名称": "Molimo unesite naziv specifikacije",
  "删除后不可恢复，确认删除吗?": "Nakon brisanja nema povratka, potvrdite brisanje?",
  "属性名": "Naziv atributa",
  "请输入属性名称": "Molimo unesite naziv atributa",
  "请输入属性值": "Molimo unesite vrijednost atributa",
  "添加属性名": "Dodaj naziv atributa",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Pregled u stvarnom vremenu",
  "营业总额": "Ukupan prihod od poslovanja",
  "有效订单": "Valjani narudžbe",
  "退款金额": "Iznos povrata",
  "销量排行榜": "Rangiranje prodaje",
  "销售额排行榜": "Rangiranje prometa",
  "订单号": "Broj narudžbe",
  "请输入订单号": "Molimo unesite broj narudžbe",
  "起始时间": "Početno vrijeme",
  "开始日期": "Početni datum",
  "结束日期": "Završni datum",
  "导出": "Izvoz",
  "全部订单": "Sve narudžbe",
  "未付款": "Neplaćeno",
  "进行中": "U tijeku",
  "已取消": "Poništeno",
  "已完成": "Dovršeno",
  "订单信息": "Informacije o narudžbi",
  "下单时间": "Vrijeme narudžbe",
  "取消申请中": "Ostvareni zahtjevi za otkazivanje",
  "实付款": "Stvarna uplata",
  "含服务费": "Uključujući servisnu naknadu",
  "含包装费": "Uključujući naknadu za pakiranje",
  "买家": "Kupac",
  "出餐状态": "Status obroka",
  "准备中": "Priprema",
  "出餐中": "Kuhanje",
  "待取餐": "Čekanje na preuzimanje",
  "交易状态": "Status transakcije",
  "支付方式": "Način plaćanja",
  "配送方式": "Način dostave",
  "订单详情": "Detalji narudžbe",
  "出餐": "Posluži obrok",
  "退款": "Povrat novca",
  "核销": "Potvrdi",
  "确定要出餐吗?": "Jeste li sigurni da želite poslužiti obrok?",
  "确定要核销吗?": "Jeste li sigurni da želite potvrditi?",
  "恭喜你，操作成功": "Čestitamo, operacija je uspješna",
  "已取消核销": "Potvrda poništena",
  "基本信息": "Osnovne informacije",
  "订单来源": "Izvor narudžbe",
  "用户": "Korisnik",
  "订单金额": "Iznos narudžbe",
  "配送费": "Naknada za dostavu",
  "服务费": "Servisna naknada",
  "优惠券抵扣": "Popust kupona",
  "积分抵扣": "Odbitak bodova",
  "满减金额": "Iznos popusta na minimalnu kupnju",
  "优惠金额": "Iznos popusta",
  "实付款金额": "Stvarni iznos uplate",
  "用餐方式": "Način objeda",
  "取餐时间": "Vrijeme preuzimanja",
  "桌号": "Broj stola",
  "修改价格": "Izmijeni cijenu",
  "门店信息": "Informacije o trgovini",
  "商品信息": "Informacije o proizvodu",
  "会员折扣价": "Cijena s popustom za članove",
  "购买数量": "Količina kupnje",
  "商品总价": "Ukupna cijena proizvoda",
  "收货信息": "Informacije o dostavi",
  "收货人": "Primatelj",
  "收货电话": "Telefon primatelja",
  "收货地址": "Adresa dostave",
  "备注": "Napomena",
  "自提用户信息": "Informacije o korisniku za samopreuzimanje",
  "用户信息": "Informacije o korisniku",
  "联系手机": "Kontaktni mobilni",
  "付款信息": "Informacije o plaćanju",
  "应付款金额": "Iznos za plaćanje",
  "支付流水号": "Broj transakcije plaćanja",
  "付款状态": "Status plaćanja",
  "付款时间": "Vrijeme plaćanja",
  "发货信息": "Informacije o dostavi",
  "发货状态": "Status isporuke",
  "取消信息": "Informacije o poništenju",
  "商家备注": "Napomena prodavača",
  "门店自提核销": "Potvrda samopreuzimanja u trgovini",
  "核销员": "Radnik za potvrdu",
  "核销状态": "Status potvrde",
  "已核销": "Potvrđeno",
  "核销时间": "Vrijeme potvrde",
  "返回上一页": "Vrati se na prethodnu stranicu",
  "确认发货": "Potvrdi isporuku",
  "确认审核": "Potvrdi pregled",
  "请选择物流公司": "Molimo odaberite logističku tvrtku",
  "请填写物流单号": "Molimo unesite broj logističke pošiljke",
  "恭喜你，发货成功": "Čestitamo, uspješno ste isporučili robu",
  "恭喜你，审核成功": "Čestitamo, uspješno ste pregledali",
  "订单价格修改": "Izmjena cijene narudžbe",
  "运费金额": "Iznos dostave",
  "最终付款价": "Konačna cijena plaćanja",
  "取消订单": "Otkaži narudžbu",
  "请输入备注": "Molimo unesite napomenu",
  "请输入退款金额": "Molimo unesite iznos povrata",
  "确认退款?": "Potvrdi povrat?",
  "已取消退款": "Povrat poništen",
  "含配送费": "Uključujući naknadu za dostavu",
  "确认送达": "Potvrdi dostavu",
  "是否确认此操作?": "Jeste li sigurni da želite potvrditi ovu operaciju?",
  "配送状态": "Status dostave",
  "备注信息": "Informacije o napomeni",
  "期望配送时间": "Očekivano vrijeme dostave",
  "订单状态": "Status narudžbe",
  "骑手姓名": "Ime dostavljača",
  "骑手电话": "Broj dostavljača",
  "操作时间": "Vrijeme operacije",
  "详情": "Detalji",
  "此操作将确认送达, 是否继续?": "Ova operacija će potvrditi dostavu, želite li nastaviti?",
  "配送时间": "Vrijeme isporuke",
  "配送信息": "Informacije o dostavi",
  "配送类型": "Vrsta dostave",
  "配送距离": "Udaljenost isporuke",
  "配送员": "Dostavljač",
  "配送电话": "Broj dostavljača",
  "配送费用": "Naknada dostave",
  "送达时间": "Vrijeme dolaska",
  "取消原因": "Razlog poništenja",
  "请输入取消原因": "Molimo unesite razlog poništenja",
  "米": "Metar",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "配送方式设置": "Postavke načina dostave",
  "商家配送": "Dostava od strane trgovca",
  "自动配送时间(分钟)": "Automatsko vrijeme dostave (minute)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Postavljanje na 0 znači bez automatske dostave. Nakon narudžbe bez dostave, automatska dostava će biti pokrenuta nakon postavljenog vremena",
  "商户编号": "ID trgovca",
  "门店编号": "ID trgovine",
  "环境": "Okolina",
  "测试环境": "Testna okolina",
  "正式环境": "Produkcijska okolina",
  "回调地址": "Adresa povratnog poziva",
  "运营城市": "Operativni grad",
  "恭喜你，上传设置成功": "Čestitamo, uspješno postavili postavke za prijenos",
  "菜品打印列表": "Popis tiskanja hrane",
  "名称": "Ime",
  "打印类型": "Vrsta ispisivanja",
  "外卖": "Dostava",
  "店内": "Konzumacija u lokalu",
  "菜品打印": "Tiskanje hrane",
  "是否开启": "Omogućiti",
  "配送打印": "Tiskanje dostave",
  "店内打印": "Tiskanje unutar objekta",
  "打印方式": "Način tiskanja",
  "付款打印": "Tiskanje plaćanja",
  "下单打印": "Tiskanje narudžbe",
  "商品分组": "Grupiranje proizvoda",
  "男": "Muško",
  "女": "Žensko",
  "未知": "Nepoznato",
  "文件管理": "Upravljanje datotekama",
  "移动至": "Premjesti u",
  "点击上传": "Kliknite za prijenos",
  "删除失败": "Brisanje nije uspjelo",
  "请选择文件": "Molimo odaberite datoteku",
  "确定移动选中的文件吗？, 是否继续?": "Jeste li sigurni da želite premjestiti odabrane datoteke? Želite li nastaviti?",
  "只能上传图片！": "Možete prenijeti samo slike!",
  "上传文件只能是图片格式!": "Prenesena datoteka mora biti u formatu slike!",
  "上传文件大小不能超过 2MB!": "Veličina prenesene datoteke ne smije premašiti 2MB!",
  "请查看/裁切其它上传图片!": "Molimo pregledajte/izrežite ostale prenesene slike!",
  "图片上传中,请等待": "Prijenos slike u tijeku, molimo pričekajte",
  "当前图片上传失败!": "Trenutni prijenos slike nije uspio!",
  "本次上传图片失败": "Prijenos slike nije uspio ovaj put",
  "本次最多只能上传1个文件": "Ovaj put možete prenijeti najviše 1 datoteku",
  "裁剪图片": "Obrezivanje slike",
  "选择优惠券": "Odaberite kupon",
  "数量": "Količina",
  "无限制": "Neograničeno",
  "请输入等级名称": "Molimo unesite naziv razine",
  "长度在3到5个字符": "Dužina treba biti između 3 i 5 znakova",
  "错了哦，这是一条错误消息": "Ups, ovo je poruka o grešci",
  "增加税率": "Dodaj poreznu stopu",
  "税率分类": "Kategorija porezne stope",
  "请输入税率分类": "Molimo unesite kategoriju porezne stope",
  "自定义税率分类": "Prilagođena kategorija porezne stope",
  "请输入税率值": "Molimo unesite vrijednost porezne stope",
  "单位是": "Jedinica je",
  "适用菜品分类": "Primjenjiva kategorija hrane",
  "请选择菜品分类": "Molimo odaberite kategoriju hrane",
  "修改税率信息": "Promijenite podatke o poreznoj stopi",
  "分类名称不能为空": "Naziv kategorije ne smije biti prazan",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Upravljanje članstvom",
  "等级管理": "Upravljanje razinama",
  "余额明细": "Detalji stanja",
  "请输入昵称": "Molimo unesite nadimak",
  "邮箱": "Email",
  "请输入邮箱地址": "Molimo unesite email adresu",
  "无等级": "Bez razine",
  "余额": "Stanje",
  "积分": "Bodovi",
  "生日": "Rođendan",
  "充值": "Dopuna",
  "恭喜你，用户删除成功": "Čestitamo, korisnik izbrisan",
  "请选择等级": "Molimo odaberite razinu",
  "管理员备注": "Administratorska bilješka",
  "请输入管理员备注": "Molimo unesite administratorsku bilješku",
  "恭喜你，用户修改成功": "Čestitamo, korisnik uspješno izmijenjen",
  "会员充值": "Dopuna članstva",
  "充值余额": "Iznos dopune",
  "当前余额": "Trenutno stanje",
  "充值方式": "Način dopune",
  "增加": "Povećanje",
  "减少": "Smanjenje",
  "最终金额": "Konačni iznos",
  "变更金额": "Promijenjeni iznos",
  "请输入变更金额": "Molimo unesite promijenjeni iznos",
  "添加等级": "Dodaj razinu",
  "等级名称": "Ime razine",
  "权重": "Težina",
  "升级条件": "Uvjeti za napredovanje",
  "等级权重": "Težina razine",
  "请输入等级权重": "Molimo unesite težinu razine",
  "权重越大，等级越高": "Što je težina veća, razina je viša",
  "等级折扣": "Popust na razini",
  "请输入等级折扣": "Molimo unesite popust na razini",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Uspunite jedan od označenih uvjeta u nastavku, član će se automatski unaprijediti na tu razinu",
  "累计消费满": "Kumulativna potrošnja doseže",
  "编辑等级": "Uredi razinu",
  "累计积分满": "Kumulativni bodovi dosežu",
  "推荐人数满": "Postignut broj preporuka",
  "恭喜你，等级修改成功": "Čestitamo, razina uspješno izmijenjena",
  "个": "komada",
  "充值设置": "Postavke dopune",
  "是否开启余额充值": "Omogućiti dopunu stanja",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Napomena: Ako je omogućeno, gumb za dopunu će biti prikazan na mobilnom kraju; ako mini-program ne prođe pregled kvalifikacija, može ostati onemogućen",
  "是否开启自定义金额": "Omogućiti prilagođeni iznos",
  "注：如开启则用户可以填写充值金额": "Napomena: Ako je omogućeno, korisnici mogu unijeti prilagođeni iznos dopune",
  "最低充值金额": "Minimalni iznos dopune",
  "注：自定义充值金额最低充值多少€": "Napomena: Koliki je minimalni iznos za prilagođen doplatu?",
  "充值说明": "Upute za dopunu",
  "充值套餐": "Paketi dopune",
  "支付金额": "Iznos plaćanja",
  "到账数量": "Primljeni iznos",
  "充值时间": "Vrijeme dopune",
  "到账金额": "Primljeni iznos",
  "赠送金额": "Iznos poklona",
  "提现设置": "Postavke podizanja sredstava",
  "是否开启提现": "Omogućiti povlačenje",
  "注：如开启则移动端显示余额提现": "Napomena: Ako je omogućeno, mobilni završetak će prikazati opciju povlačenja sredstava",
  "提现比例": "Odnos povlačenja",
  "注：提现比例请填写数字0~100": "Napomena: Molimo unesite postotak povlačenja između 0 i 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Primjer: Iznos povlačenja (100,00 RMB) * Postotak povlačenja (100%) = Rezultantni iznos (100€)",
  "最低提现金额": "Minimalni iznos povlačenja",
  "注：最低提现金额多少元": "Napomena: Koliki je minimalni iznos za podizanje sredstava u juanima?",
  "请选择状态": "Odaberite status",
  "提现方式": "Način povlačenja",
  "请选择提现方式": "Odaberite način povlačenja",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bankovna kartica",
  "请输入用户ID": "Molimo unesite korisnički ID",
  "请输入昵称/姓名/手机号": "Molimo unesite nadimak/ime/broj telefona",
  "提现信息": "Informacije o povlačenju",
  "支付宝名称": "Ime Alipay računa",
  "支付宝账号": "Alipay račun",
  "银行名称": "Naziv banke",
  "开户名": "Ime vlasnika računa",
  "银行卡号": "Broj bankovne kartice",
  "申请时间": "Vrijeme zahtjeva",
  "审核时间": "Vrijeme pregleda",
  "微信付款": "WeChat plaćanje",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Ova radnja će koristiti WeChat-ovu funkciju plaćanja tvrtke za transfer na novčanik. Jeste li sigurni da želite nastaviti?",
  "添加充值套餐": "Dodaj paket dopune",
  "套餐名称": "Ime paketa",
  "请输入套餐名称": "Molimo unesite ime paketa",
  "请输入支付金额": "Molimo unesite iznos plaćanja",
  "请输入赠送金额": "Molimo unesite iznos poklona",
  "请输入到账金额": "Molimo unesite iznos koji će biti primljen",
  "请输入排序": "Molimo unesite redoslijed",
  "用户ID": "Identifikacija korisnika",
  "会员卡管理": "Upravljanje članskom karticom",
  "领取记录": "Zapisi o preuzimanju",
  "删除记录": "Obriši zapis",
  "请输入关键词": "Molimo unesite ključnu riječ",
  "过期": "Isteklo",
  "有效": "Važeće",
  "客户信息": "Podaci o kupcu",
  "会员卡名称": "Ime članske kartice",
  "有效期": "Valjanost",
  "折": "Popust",
  "领取时间": "Vrijeme preuzimanja",
  "延期": "Produljenje",
  "撤销": "Opoziv",
  "添加会员卡": "Dodaj člansku karticu",
  "启用": "Aktiviraj",
  "月": "Mjesec",
  "永久有效": "Neograničen rok trajanja",
  "领取数量": "Količina preuzimanja",
  "发卡": "Izdavanje kartice",
  "领取设置": "Postavke preuzimanja",
  "请检查必填项是否填写完整": "Molimo provjerite jesu li obvezna polja potpuno popunjena",
  "领取人数": "Broj preuzimanja",
  "删除时间": "Vrijeme brisanja",
  "请填写有效期": "Molimo unesite valjanost",
  "有效期限（月），0为永久有效": "Valjanost (u mjesecima), 0 za neograničenu valjanost",
  "请填写价格": "Molimo unesite cijenu",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "Iznos koji korisnici moraju platiti za kupnju članske kartice, 0 za besplatno preuzimanje",
  "使用须知": "Upute za korištenje",
  "请填写使用须知": "Molimo unesite upute za korištenje",
  "请填写会员卡名称": "Molimo unesite ime članske kartice",
  "卡片类型": "Vrsta kartice",
  "卡片样式": "Stil kartice",
  "请填写排序": "Molimo unesite redoslijed",
  "会员权益": "Povlastice članova",
  "无折扣": "Bez popusta",
  "请填写折扣": "Molimo unesite popust",
  "开卡赠送": "Poklon uz aktivaciju kartice",
  "优惠券": "Kupon",
  "请填写积分数量": "Molimo unesite količinu bodova",
  "请填写余额数量": "Molimo unesite iznos na računu",
  "请填写优惠券": "Molimo unesite kupon",
  "添加优惠券": "Dodaj kupon",
  "券名称": "Ime kupona",
  "每人领取数量": "Količina po osobi",
  "选择优惠券弹出层": "Odabir Popup kupona",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Odabrali ste već petnaest kuponai, ako želite zamijeniti, molimo obrišite ostale!",
  "产品编码": "Kôd proizvoda",
  "请填写产品编码": "Molimo unesite kôd proizvoda",
  "产品划线价": "Listna cijena proizvoda",
  "请填写产品划线价": "Molimo unesite listnu cijenu proizvoda",
  "商品重量": "Težina proizvoda",
  "请填写商品重量": "Molimo unesite težinu proizvoda",
  "批量设置": "Serija postavki",
  "划线价": "Listna cijena",
  "重量": "Težina",
  "应用": "Primijeni",
  "规格图片": "Slika specifikacija",
  "规格值": "Vrijednost specifikacije",
  "请输入规格值": "Molimo unesite vrijednost specifikacije",
  "请填写规则名或规则值": "Molimo unesite naziv pravila ili njegovu vrijednost",
  "规格值不能为空": "Vrijednost specifikacija ne može biti prazna",
  "卡名称": "Ime kartice",
  "卡ID": "ID kartice",
  "无": "Nema",
  "选择会员": "Odaberi člana",
  "恭喜你，发卡成功": "Čestitamo, izdavanje kartice uspješno",
  "副卡数": "Broj dodatnih kartica",
  "张": "komada",
  "选择日期": "Odabir datuma",
  "签到设置": "Postavke prijave",
  "签到记录": "Zapisi o prijavi",
  "是否开启签到有礼": "Omogućiti nagrade za prijavu",
  "每日签到固定奖励": "Fiksna nagrada za dnevnu prijavu",
  "每日签到送": "Nagrada za dnevnu prijavu",
  "递增奖励": "Povećanje nagrade",
  "有": "Da",
  "第二天起递增奖励": "Povećanje nagrade od drugog dana",
  "请输入第二天起递增积分数": "Molimo unesite povećanje bodova od drugog dana",
  "第": "Dan",
  "请输入第几天不再递增": "Unesite dan kada se povećanje zaustavlja",
  "天起不再递增": "Ne više povećanje od tog dana",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Dodatna nagrada za kontinuiranu prijavu (Kada se dosegne maksimalni broj dana za dodatnu nagradu, daljnje prijave neće dobiti dodatne nagrade; brojanje se ponovno pokreće nakon propuštene prijave)",
  "额外奖励": "Dodatna nagrada",
  "连续签到": "Kontinuirana prijava",
  "请输入连续签到天数": "Molimo unesite broj dana kontinuirane prijave",
  "积分奖励": "Nagrada u bodovima",
  "送": "darivanje",
  "请输入连续签到天数的积分": "Molimo unesite bodove za kontinuirane dane prijave",
  "规则": "Pravila",
  "规则说明": "Objašnjenje pravila",
  "请添加至少一项额外奖励！": "Molimo dodajte barem jednu dodatnu nagradu!",
  "天数不能为空！": "Dani ne mogu biti prazni!",
  "请输入连续签到积分数！": "Molimo unesite broj bodova za kontinuirane prijave!",
  "每日签到送积分有误": "Greška u nagradi za dnevnu prijavu",
  "恭喜你，保存成功": "Čestitamo, uspješno spremljeno",
  "连续签到天数": "Broj dana kontinuirane prijave",
  "不限": "Neograničeno",
  "签到时间": "Vrijeme prijave",
  "时间": "Vrijeme",
  "请输入用户昵称": "Molimo unesite korisnički nadimak",
  "签到日期": "Datum prijave",
  "活动奖品": "Nagrade aktivnosti",
  "取号记录": "Zapisi o rezervaciji broja",
  "桌号管理": "Upravljanje stolovima",
  "取号设置": "Postavke rezervacije broja",
  "请输入手机号": "Molimo unesite broj telefona",
  "待叫号": "Na čekanju",
  "已入座": "Sjednuto",
  "已过号": "Propušteno",
  "就餐号": "Broj za blagovaonicu",
  "就餐人数": "Broj gostiju",
  "桌位名称": "Ime stola",
  "取号时间": "Vrijeme rezervacije",
  "待取号": "Na čekanju",
  "是否开启打印": "Omogućiti ispis",
  "须知": "Upute",
  "请输入须知": "Molimo unesite upute",
  "商家说明": "Opis prodavatelja",
  "请输入商家说明": "Molimo navedite opis prodavatelja",
  "取号规则": "Pravila rezervacije broja",
  "等待时间": "Vrijeme čekanja",
  "人数最小值": "Minimalni broj osoba",
  "人数最大值": "Maksimalni broj osoba",
  "等待时间(分钟)": "Vrijeme čekanja (minute)",
  "请输入桌位名称": "Molimo unesite naziv stola",
  "请输入人数最小值": "Molimo unesite minimalni broj osoba",
  "请输入人数最大值": "Molimo unesite maksimalni broj osoba",
  "请输入等待时间": "Molimo unesite vrijeme čekanja",
  "商品设置": "Postavke proizvoda",
  "兑换记录": "Evidencija zamjene",
  "活动名称": "Naziv aktivnosti",
  "请输入活动名称": "Molimo unesite naziv aktivnosti",
  "活动列表": "Popis aktivnosti",
  "添加活动": "Dodaj aktivnost",
  "活动价格": "Cijena aktivnosti",
  "发放数量": "Količina distribucije",
  "参与人数": "Broj sudionika",
  "终止": "Prekini",
  "购买记录": "Zapisnici o kupnji",
  "新增活动会场": "Dodaj novu lokaciju aktivnosti",
  "活动标题": "Naziv aktivnosti",
  "请输入活动标题": "Ljubazno unesite naziv aktivnosti",
  "活动日期": "Datum aktivnosti",
  "礼包设置": "Postavke darovnog paketa",
  "优惠券id": "ID kupona",
  "购买设置": "Postavke kupnje",
  "购买金额": "Iznos kupnje",
  "会员购买等级": "Članstvo u razini kupovine",
  "指定等级": "Određena razina",
  "购买次数": "Učestalost kupnje",
  "限购": "Limit kupnje",
  "每人限购": "Limit kupnje po osobi",
  "次": "Puta",
  "发放设置": "Postavke distribucije",
  "请输入发放数量": "Molimo unesite količinu distribucije",
  "返回": "Povratak",
  "请勿重复添加": "Molimo izbjegavajte dvostruke dodatke",
  "至少选择一个优惠券": "Molimo odaberite barem jedan kupon",
  "新增活动": "Dodaj novu aktivnost",
  "券包设置": "Postavke paketa kupona",
  "下载推广码": "Preuzmi promotivni kod",
  "下载类型": "Vrsta preuzimanja",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Prije korištenja ove značajke, idite na stražnju stranu mini programa, i u 'Postavke'-'Postavke sučelja'-'Pratite komponentu javnog računa,' postavite javni račun koji će se prikazati. Napomena: postavljeni javni račun mora odgovarati entitetu mini programa",
  "去配置": "Idi na konfiguraciju",
  "若没有配置公众号，功能将不生效": "Ako javni račun nije konfiguriran, funkcija neće imati učinka",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Samo kada mini program uđe iz sljedećih scena tijekom svog životnog ciklusa, mogućnosti prikaza i vođenja pratnje javnog računa mogu biti aktivirane",
  "当小程序从扫小程序码打开时": "Kada se mini program otvori skeniranjem mini-programskog koda",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Kada se vratite na mini program iz drugog mini programa, ako prethodni mini program nije uništen, komponenta će zadržati stanje s prošlog puta kada je mini program bio otvoren",
  "公众号关注": "Pretplata na javni račun",
  "新客设置": "Postavke za nove korisnike",
  "是否开启活动": "Je li aktivnost omogućena?",
  "活动时间": "Vrijeme trajanja aktivnosti",
  "背景图": "Pozadinska slika",
  "赠送优惠券": "Darivanje kupona",
  "请选择优惠券": "Molimo odaberite kupon",
  "赠送积分": "Darivanje bodova",
  "请输入赠送积分": "Molimo unesite bodove koji se daruju",
  "直播同步": "Sinkronizacija uživo",
  "同步直播": "Sinkronizirajte prijenos uživo",
  "请输入直播间名称/主播昵称": "Molimo unesite ime prostora za prijenos uživo / nadimak voditelja",
  "直播间ID": "ID prostora za prijenos uživo",
  "直播间名称": "Ime prostora za prijenos uživo",
  "主播昵称": "Nadimak voditelja",
  "直播开始时间": "Vrijeme početka uživo",
  "直播结束时间": "Vrijeme završetka uživo",
  "直播间状态": "Status prostora za prijenos uživo",
  "置顶": "Zakači na vrh",
  "未置顶": "Nije zaljepljeno",
  "已置顶": "Zaljepljeno",
  "设为置顶": "Postavi kao vrh",
  "取消置顶": "Odkači",
  "直播中": "Uživo",
  "未开始": "Nije započeto",
  "已结束": "Završeno",
  "禁播": "Zabrana prijenosa uživo",
  "暂停": "Pauza",
  "异常": "Izuzetak",
  "已过期": "Isteklo",
  "置顶成功": "Uspješno zaljepljeno",
  "邀请活动": "Dogadaj pozivanja",
  "个人中心图片": "Slika osobnog centra",
  "请输入用户昵称/手机号": "Molimo unesite nadimak korisnika/broj telefona",
  "邀请人": "Pozivatelj",
  "被邀请人": "Pozvani",
  "参加时间": "Vrijeme sudjelovanja",
  "个人中心显示": "Prikaz osobnog centra",
  "参与记录": "Zapisnici o sudjelovanju",
  "礼品记录": "Zapisnici o darovima",
  "推广二维码": "Promotivni QR kod",
  "编辑活动会场": "Uredi mjesto događanja",
  "请输入分享标题": "Molimo unesite naslov za dijeljenje",
  "请输入分享内容": "Molimo unesite sadržaj za dijeljenje",
  "分享内容": "Sadržaj za dijeljenje",
  "分享图": "Slika za dijeljenje",
  "个人中心状态": "Stanje osobnog centra",
  "邀请成功的条件": "Uvjeti za uspješan poziv",
  "邀请成为会员": "Poziv za postati član",
  "邀请成为会员且消费": "Poziv za postati član i potrošiti",
  "礼品设置": "Postavke darova",
  "奖项": "Nagrada",
  "每邀请": "Po pozivu",
  "人获得礼品": "Osoba dobiva dar",
  "添加奖励项": "Dodaj stavku nagrade",
  "请上传背景图": "Molimo unesite pozadinsku sliku",
  "请上传分享图": "Molimo unesite sliku za dijeljenje",
  "请添加奖项": "Molimo dodajte dar",
  "开启首页推送": "Omogući push na početnoj stranici",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Preporučuje se promjena aktivnosti; promjena ovog imena prilagodit će iskačuće prozore na početnoj stranici trgovine prema ovom imenu",
  "类型": "Vrsta",
  "图文": "Slika i tekst",
  "纯图": "Čista slika",
  "领取优惠券": "Preuzimanje kupona",
  "请输入标题": "Molimo unesite naslov",
  "弹窗图片": "Slika za iskačući prozor",
  "图片为2M以内大小，格式限png，jpg格式": "Veličina slike treba biti unutar 2 MB i u PNG ili JPG formatu",
  "按钮文案": "Tekst gumba",
  "简介说明": "Koncizno objašnjenje",
  "请输入说明": "Ljubazno unesite objašnjenje",
  "点击选择你要链接的位置": "Kliknite za označavanje željene lokacije povezivanja",
  "跳转地址": "Adresa preusmjeravanja",
  "最多可以添加三张": "Dozvoljeno je dodavanje najviše tri slike",
  "最多添加3张优惠券": "Maksimalno dopušteni limit: 3 kupona",
  "标题不能为空": "Naslov ne smije biti prazan",
  "请选择跳转链接": "Odaberite poveznicu za preusmjeravanje",
  "请选择优惠卷": "Odaberite kupon",
  "请上传图片": "Molimo učitajte sliku",
  "团购订单": "Narudžbe grupne kupovine",
  "团购管理": "Upravljanje grupnom kupovinom",
  "团购设置": "Postavke grupne kupovine",
  "订单设置": "Postavke narudžbe",
  "未支付订单": "Nenaplative narudžbe",
  "请输入关闭时间": "Molimo unesite vrijeme zatvaranja",
  "分钟后自动关闭": "Automatsko zatvaranje nakon minuta",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Nenaplative narudžbe automatski se zatvaraju nakon n minuta; postavite na 0 za nema automatskog zatvaranja",
  "团购保障": "Zaštita grupne kupovine",
  "使用门店": "Upotreba dućana",
  "待付款": "Čeka na plaćanje",
  "待使用": "Čeka na upotrebu",
  "已退款": "Vraćeno",
  "使用门店名称": "Naziv dućana za upotrebu",
  "门店联系人": "Kontakt osoba u dućanu",
  "门店电话": "Broj telefona dućana",
  "团购信息": "Informacije o grupnoj kupovini",
  "券码信息": "Informacije o kodu kupona",
  "核销券码": "Unovčite kôd kupona",
  "添加团购": "Dodaj grupnu kupovinu",
  "团购名称": "Naziv grupne kupovine",
  "销售价格": "Cijena prodaje",
  "虚拟销量": "Virtualna prodaja",
  "部分": "Dio",
  "基础设置": "Osnovna postavka",
  "购买须知": "Upute za kupnju",
  "团购详情": "Detalji o grupnoj kupovini",
  "团购须知": "Upute za grupnu kupovinu",
  "请输入团购名称": "Molimo unesite naziv grupne kupovine",
  "到期类型": "Vrsta isteka",
  "购买后生效": "Učinkovito nakon kupnje",
  "固定时间": "Fiksno vrijeme",
  "有效天数": "Period važenja u danima",
  "请输入有效天数": "Molimo unesite period važenja u danima",
  "有效时间": "Validno vrijeme",
  "请输入有效时间": "Molimo unesite važeće vrijeme",
  "团购图片": "Slika grupne kupovine",
  "请上传团购图片": "Ljubazno učitajte sliku grupne kupovine",
  "请输入划线价格": "Molimo unesite cijenu s crtom",
  "请输入销售价格": "Molimo unesite cijenu prodaje",
  "请输入虚拟销量": "Molimo unesite virtualnu prodajnu količinu",
  "适用门店": "Primjenjivi dućani",
  "请选择门店": "Odaberite dućan",
  "团购状态": "Status grupne kupovine",
  "每日限购数量": "Dnevno ograničenje kupovine",
  "每个会员每日购买的最大数量，0为不限购": "Maksimalna količina koju član može kupiti dnevno; 0 za neograničeno",
  "商家名称": "Naziv trgovca",
  "平台": "Platforma",
  "满类型": "Vrsta kriterija",
  "满额": "Iznos ispunjenja",
  "满件数": "Broj potrebnih komada",
  "满值": "Vrijednost ispunjenja",
  "减类型": "Vrsta odbitka",
  "减金额": "Iznos odbitka",
  "打折": "Popust",
  "减值": "Vrijednost odbitka",
  "编辑活动": "Uredi aktivnost",
  "满金额": "Puni iznos",
  "请输入满值": "Molimo unesite vrijednost ispunjenja",
  "如果是打折，填写80，表示打8折": "Ako je popust, unesite 80 za 20% popusta",
  "满额免配送费设置": "Besplatna dostava na iznos ispunjenja",
  "是否开启满额免配送费": "Omogućite besplatnu dostavu na iznos ispunjenja",
  "单笔订单满": "Jedna narudžba preko",
  "如果开启满额免配送费，设置0为全场免配送费": "Ako je omogućena besplatna dostava na iznos ispunjenja, postavite 0 za potpuno besplatnu dostavu",
  "入驻申请": "Prijava za useljenje",
  "配送订单": "Narudžbe dostave",
  "提现申请": "Zahtjev za povlačenje",
  "配送设置": "Postavke dostave",
  "退出申请": "Zahtjev za izlaz",
  "正常": "Normalno",
  "押金": "Složi",
  "累计佣金": "Akumulirana provizija",
  "可提现佣金": "Provizija dostupna za povlačenje",
  "已提现佣金": "Provizija već povučena",
  "提现明细": "Detalji povlačenja",
  "申请条件": "Uvjeti prijave",
  "结算": "Račun",
  "是否开启押金支付": "Omogućiti plaćanje predujma",
  "是否审核": "Zahtijeva li pregled",
  "需后台审核": "Zahtijeva pregled pozadine",
  "无需审核": "Ne treba pregled",
  "产品列表弹出层": "Popis proizvoda na izborniku",
  "已选择该商品": "Proizvod već odabran",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Napomena: Za WeChat Pay, treba zatražiti funkciju prijenosa na račun novčanika",
  "微信提现方式": "Metoda povlačenja putem WeChata",
  "微信提现到零钱": "Povuci na WeChat novčanik",
  "商家转账到零钱": "Prijenos trgovca na novčanik",
  "注：根据实际产品开通情况选择": "Odaberite prema stvarnoj aktivaciji proizvoda",
  "最低提现额度": "Minimalni iznos povlačenja",
  "佣金结算时间": "Vrijeme računanja provizije",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Napomena: Provizije za dostavu računaju se n sati nakon završetka narudžbe; Postavite na 0 za trenutno računanje",
  "请至少选择一种提现方式": "Molimo odaberite barem jednu metodu povlačenja",
  "佣金结算": "Računanje provizije",
  "是否结算佣金": "Je li provizija obračunata?",
  "已结算": "Obračunato",
  "未结算": "Nije obračunato",
  "送达状态": "Status dostave",
  "查看详情": "Pogledaj detalje",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Ova će operacija koristiti WeChat Enterprise Payment za prijenos na vaš račun. Jeste li sigurni u transakciju?",
  "身份证号": "Broj osobne iskaznice",
  "待交押金": "Naplatiti jamčevinu",
  "审核方式": "Način pregleda",
  "查看": "Pregledaj",
  "配送员审核": "Pregled dostavljača",
  "添加外卖商品": "Dodaj proizvode za dostavu",
  "序号": "Broj",
  "活动折扣": "Popust na aktivnosti",
  "活动库存": "Zaliha aktivnosti",
  "添加店内商品": "Dodaj proizvode u trgovini",
  "优惠券列表": "Popis kupona",
  "发送优惠券": "Pošalji kupone",
  "发送对象": "Primatelj",
  "全站会员": "Svi članovi web stranice",
  "指定会员": "Odabrani član",
  "选择会员等级": "Odaberite razinu članstva",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Primatelj je dosegnuo limit za primanje određenog kupona i više ga neće primati",
  "发送成功": "Uspješno poslano",
  "优惠券ID": "ID kupona",
  "优惠券名称": "Naziv kupona",
  "优惠券类型": "Vrsta kupona",
  "最低消费金额": "Minimalni iznos potrošnje",
  "优惠方式": "Metoda popusta",
  "立减": "Odmah smanjenje",
  "打": "Popust",
  "领取": "Primanje",
  "天内有效": "Važi za dane",
  "发放总数量": "Ukupna količina distribucije",
  "不限制": "Neograničeno",
  "已领取数量": "Broj primljenih",
  "修改优惠券": "Uredi kupon",
  "请输入优惠券名称": "Molimo unesite naziv kupona",
  "例如：满100减10": "Na primjer: Potroši 100 i dobiješ 10 popusta",
  "优惠券颜色": "Boja kupona",
  "蓝色": "Plava",
  "红色": "Crvena",
  "紫色": "Ljubičasta",
  "黄色": "Žuta",
  "满减券": "Kupon smanjenja",
  "折扣券": "Kupon za popust",
  "减免金额": "Iznos smanjenja",
  "请输入减免金额": "Molimo unesite iznos smanjenja",
  "折扣率": "Stopa popusta",
  "请输入折扣率": "Molimo unesite stopu popusta",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Raspon stope popusta je od 0 do 10. Na primjer, 9.5 predstavlja popust od 5%, a 0 znači bez popusta",
  "请输入最低消费金额": "Molimo unesite minimalni iznos potrošnje",
  "后生效": "Aktivno nakon",
  "请输入发放总数量": "Molimo unesite ukupnu količinu distribucije",
  "限制领取的优惠券数量，-1为不限制": "Ograničite broj kupona koji se mogu primiti, -1 ako nema ograničenja",
  "是否显示在领券中心": "Prikazuje li se u centru kupona?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Pop-up upozorenje kao što je prikazano na slici prikazuje se samo kad novi korisnik prvi put pristupi mini programu",
  "引导收藏": "Voditi prikupljanje",
  "编辑类型": "Vrsta uređivanja",
  "生日设置": "Postavke rođendana",
  "手机短信": "SMS poruke",
  "分销商用户": "Korisnici distributera",
  "分销订单": "Narudžbe distribucije",
  "分销海报": "Plakati distribucije",
  "推荐人": "Preporučitelj",
  "下级用户": "Podređeni korisnici",
  "一级": "Prvi nivo",
  "二级": "Drugi nivo",
  "三级": "Treći nivo",
  "成为时间": "Datum postajanja",
  "下级": "Podređeni",
  "加入时间": "Datum pridruživanja",
  "分销商条件": "Uvjeti distributera",
  "佣金设置": "Postavke provizije",
  "自定义文字": "Prilagođeni tekst",
  "申请协议": "Ugovor o prijavi",
  "页面背景图": "Pozadinska slika stranice",
  "分销中心页面": "Stranica centra distribucije",
  "页面标题": "Naziv stranice",
  "分销中心": "Centar distribucije",
  "非分销商提示": "Upozorenje za ne-distributera",
  "您还不是分销商，请先提交申请": "Još niste distributer, molimo podnesite zahtjev prvo",
  "申请成为分销商": "Zahtjev za postajanje distributerom",
  "立即加入": "Pridruži se odmah",
  "可提现": "Dostupno za povlačenje",
  "待提现佣金": "Čekajuća provizija za povlačenje",
  "待提现": "Na čekanju za povlačenje",
  "已提现金额": "Ukupno povučeni iznos",
  "去提现": "Povuci sada",
  "申请成为分销商页面": "Stranica za prijavu kao distributer",
  "请填写申请信息": "Molimo unesite informacije o prijavi",
  "分销商申请协议": "Ugovor o prijavi distributera",
  "申请成为经销商": "Zahtjev za postajanje dilera",
  "审核中提示信息": "Obavijest o pregledu",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Vaše je zahtjev zaprimljen i provjerava se informacija, molimo strpljivo pričekajte.",
  "去商城逛逛": "Idi u kupovinu u trgovinu",
  "分销订单页面": "Stranica s narudžbama distribucije",
  "我的团队页面": "Moja stranica tima",
  "我的团队": "Moj tim",
  "团队总人数": "Ukupan broj članova tima",
  "一级团队": "Primarni tim",
  "二级团队": "Sekundarni tim",
  "三级团队": "Tercijarni tim",
  "提现明细页面": "Stranica detalja o povlačenju",
  "审核中": "U pregledu",
  "申请提现页面": "Stranica zahtjeva za povlačenje",
  "申请提现": "Podnesi zahtjev za povlačenje",
  "请输入要提取的金额": "Molimo unesite iznos koji želite povući",
  "最低提现佣金": "Minimalna provizija za povlačenje",
  "提交申请": "Pošalji zahtjev",
  "佣金结算天数": "Dani razduživanja provizije",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Napomena: Provizija na završenoj narudžbi isplaćuje se distributeru n dana nakon završetka. Ako je postavljeno na 0 dana, isplata će biti izvršena odmah po završetku narudžbe",
  "成为分销商条件": "Uvjeti za postajanje distributerom",
  "购买指定商品成为分销商": "Postani distributer kupovinom određenih proizvoda",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Automatsko postajanje distributerom nakon plaćanja određenih proizvoda, bez potrebe za pregledom pozadine",
  "选择商品": "Odaberi proizvode",
  "成为下线条件": "Uvjeti postajanja podređenim",
  "首次点击分享链接": "Prvo kliknite na poveznicu za dijeljenje",
  "一级佣金比例": "Stopa provizije prvog nivoa",
  "佣金比例范围 0% - 100%": "Raspon stope provizije od 0% - 100%",
  "二级佣金比例": "Stopa provizije drugog nivoa",
  "三级佣金比例": "Stopa provizije trećeg nivoa",
  "是否开启分销功能": "Omogućiti funkciju distribucije",
  "分销层级": "Nivoi distribucije",
  "一级分销": "Prva razina distribucije",
  "二级分销": "Druga razina distribucije",
  "三级分销": "Treća razina distribucije",
  "分销商内购": "Interni prodajni proizvodi distributera",
  "如开启，分销商自己购买商品，获得一级佣金": "Ako je omogućeno, distributeri će dobiti proviziju prvog nivoa za svoje kupovine",
  "分销中心首页": "Naslovnica centra za distribuciju",
  "尺寸：宽750像素 高度227像素": "Dimenzije: Širina 750 piksela, Visina 227 piksela",
  "申请成为分销商页": "Stranica za prijavu kao distributer",
  "申请提现页": "Stranica zahtjeva za povlačenje",
  "分销海报设置": "Postavke plakata distribucije",
  "海报背景图": "Pozadinska slika plakata",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimenzije: Širina 750 piksela, Visina veća ili jednaka 1200 piksela",
  "头像宽度": "Širina profila",
  "头像样式": "Stil profila",
  "正方形": "Kvadratni",
  "圆形": "Kružni",
  "昵称字体大小": "Veličina fonta nadimka",
  "昵称字体颜色": "Boja fonta nadimka",
  "小程序码宽度": "Širina mini programa koda",
  "小程序码样式": "Stil mini programa koda",
  "分销商": "Distributer",
  "一级分销商": "Primarni distributer",
  "分销佣金": "Distribucijska provizija",
  "二级分销商": "Sekundarni distributer",
  "三级分销商": "Tercijarni distributer",
  "分销商审核": "Pregled distributera",
  "积分明细": "Detalji bodova",
  "变动数量": "Promjena količine",
  "积分名称": "Naziv bodova",
  "例": "Primjer",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Nakon promjene naziva bodova, svi nazivi na stranicama kupaca bit će prilagođeni",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Trgovci koriste prilagođene nazive bodova za brendiranje. Na primjer, JD koristi 'JD Beans', a Taobao koristi 'Treasure Coins'",
  "积分说明": "Objašnjenje bodova",
  "积分赠送": "Davanje bodova",
  "是否开启购物送积分": "Omogućiti bodove za kupovinu",
  "积分赠送规则": "Pravila davanja bodova",
  "如开启则订单完成后赠送用户积分": "Ako je omogućeno, bodovi se dodjeljuju korisnicima nakon završetka narudžbe",
  "订单确认收货已完成": "Potvrda narudžbe i primitka je zaključena",
  "已完成订单超出后台设置的申请售后期限": "Završene narudžbe premašuju postavljeno vremensko ograničenje za postprodajni rok iz pozadine",
  "积分赠送比例": "Stopa davanja bodova",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Molim vas da unesete postotak između 0 i 100; troškovi dostave ne sudjeluju u dodjeli bodova",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Statistika prodaje",
  "会员统计": "Statistika članova",
  "订单概况": "Pregled narudžbi",
  "商品概况": "Pregled proizvoda",
  "今日": "Danas",
  "累积会员数": "Ukupan broj članova",
  "新增会员数": "Novi članovi",
  "成交会员数": "Broj članova u transakciji",
  "排行榜": "Ljestvica",
  "用户消费榜": "Rangiranje potrošača",
  "积分排行榜": "Ljestvica bodova",
  "邀请人排行榜": "Ljestvica poziva",
  "成交会员占比": "Postotak članova u transakciji",
  "今天": "Danas",
  "最近7天": "Proteklih 7 dana",
  "最近30天": "Prote 30 dana",
  "最近90天": "Proteklih 90 dana",
  "最近180天": "Prote 180 dana",
  "最近1年": "Prote godine",
  "最近2年": "Prote 2 godine",
  "所有占比": "Opći omjer",
  "成交会员": "Članovi u transakciji",
  "未成交会员": "Neobavljeni članovi",
  "新增会员": "Novi članovi",
  "最近一周": "Prošle sedmice",
  "最近一个月": "Prošli mjesec",
  "最近三个月": "Protekla tri mjeseca",
  "选择店铺": "Odaberi trgovinu",
  "查询日期": "Datum upita",
  "近七天": "Posljednjih sedam dana",
  "近十五天": "Posljednjih petnaest dana",
  "自定义时间": "Prilagođeno vrijeme",
  "日期": "Datum",
  "有效订单数": "Broj valjanih narudžbi",
  "选择时间": "Odaberi vrijeme",
  "交易统计": "Statistika transakcija",
  "订单数": "Broj narudžbi",
  "客单价": "Prosječna vrijednost narudžbe",
  "付款订单": "Plaćene narudžbe",
  "付款人数": "Broj platiša",
  "商品统计": "Statistika proizvoda",
  "在售商品": "Dostupni proizvodi",
  "件": "Stavka",
  "已付款商品": "Plaćeni proizvodi",
  "销量TOP10": "Top 10 prodaje",
  "浏览TOP10": "Top 10 pregleda",
  "浏览": "Pregled",
  "排行类型": "Vrsta rangiranja",
  "商品总数": "Ukupan broj proizvoda",
  "已上架商品": "Proizvodi na polici",
  "已下架商品": "Proizvodi van prodaje",
  "商品导出": "Izvoz proizvoda",
  "商品总销量": "Ukupna prodaja proizvoda",
  "商品总销售额": "Ukupan iznos prodaje proizvoda",
  "资产总览": "Pregled imovine",
  "财务对账": "Financijsko usklađivanje",
  "交易记录": "Zapisnici transakcija",
  "店铺结算": "Račun trgovine",
  "待结算金额": "Iznos čekanja na obračun",
  "已结算金额": "Obračunati iznos",
  "交易概况": "Pregled transakcija",
  "外卖统计": "Statistika dostave",
  "店内统计": "Statistika u trgovini",
  "订单类型": "Vrsta narudžbe",
  "应收金额": "Iznos koji se očekuje",
  "实付金额": "Stvarni iznos plaćanja",
  "账户概况": "Pregled računa",
  "订单编号": "Broj narudžbe",
  "支付状态": "Status plaćanja",
  "付款方式": "Način plaćanja",
  "订单费用": "Troškovi narudžbe",
  "优惠": "Popust",
  "商户实际收入": "Stvarni prihod trgovca",
  "商品ID": "ID proizvoda",
  "小计": "Suma",
  "请输入提现金额": "Unesite iznos za podizanje",
  "请输入打款方式": "Unesite način plaćanja",
  "支付宝真实姓名": "Pravo ime Alipay-a",
  "请输入支付宝真实姓名": "Unesite pravo ime Alipay-a",
  "开户行名称": "Naziv banke",
  "银行开户名": "Ime bankovnog računa",
  "真实姓名": "Pravo ime",
  "应付金额": "Iznos koji treba platiti",
  "实付总额": "Ukupni iznos plaćanja",
  "商户": "Trgovac",
  "结算金额": "Iznos naseljen",
  "店铺结算金额": "Iznos računa trgovine",
  "操作提示": "Savjeti za upravljanje",
  "订单结算金额 = 店铺结算总金额(含运费)": "Iznos obračuna narudžbe = Ukupan iznos računa trgovine (uključujući troškove dostave)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Prihod trgovine = Ukupan iznos računa trgovine - Iznos povrata novca trgovine",
  "订单日期": "Datum narudžbe",
  "订单结算金额": "Iznos obračuna narudžbe",
  "配送费金额": "Iznos troškova dostave",
  "商品编码": "Šifra proizvoda",
  "可用余额": "Dostupno stanje",
  "提现概况": "Pregled isplate",
  "搜索": "Pretraži",
  "支出": "Trošak",
  "金额": "Iznos",
  "收支类型": "Vrsta prihoda i rashoda",
  "确认要退吗?": "Da li potvrđujete povrat?",
  "申请成功": "Zahtjev uspješan",
  "门店总金额": "Ukupan iznos trgovine",
  "累计收入": "Akumulirani prihod",
  "访客数": "Broj posjetitelja",
  "访问量": "Broj posjeta",
  "店铺收藏数": "Broj favorita trgovine",
  "商品收藏数": "Broj favorita proizvoda",
  "访问数": "Broj posjeta",
  "收藏数": "Broj favorita",
  "数": "Broj",
  "待支付": "Na čekanju za plaćanje",
  "实际到账": "Stvarni primljeni iznos",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "物流公司": "Logistička tvrtka",
  "chatgpt设置": "ChatGPT Postavke",
  "消息设置": "Postavke poruka",
  "短信设置": "SMS postavke",
  "上传设置": "Postavke prijenosa",
  "清理缓存": "Brisanje predmemorije",
  "网址后缀英文名称": "Engleski naziv za web stranicu sufiksa",
  "英文名称": "Englesko ime",
  "默认头像": "Zadano avatar",
  "英文名称必须只包含数字和英文字母": "Englesko ime mora sadržavati samo brojeve i slova",
  "恭喜你，商城设置成功": "Čestitamo, postavke trgovine uspješno su primijenjene",
  "表单数据不符合规则": "Podaci obrasca ne odgovaraju pravilima",
  "剩余额度": "Preostali limit",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Kada je saldo nedovoljan, funkcije poput inteligentne korisničke podrške, AI magičnog stvaranja i višejezičnog prevođenja bit će onemogućene",
  "使用明细": "Detalji korištenja",
  "消费": "Potrošnja",
  "额度": "Kvota",
  "数据缓存": "Predmemorija podataka",
  "恭喜你，清理成功": "Čestitamo, proces čišćenja je uspješan",
  "管理员列表": "Popis administratora",
  "角色管理": "Upravljanje ulogama",
  "登录日志": "Zapisnik ulaska",
  "操作日志": "Zapisnik operacija",
  "添加管理员": "Dodaj administratora",
  "管理员ID": "ID administratora",
  "用户名": "Korisničko ime",
  "所属角色": "Dodijeljena uloga",
  "超级管理员": "Super administrator",
  "所属门店": "Pripadajuća trgovina",
  "门店状态": "Status trgovine",
  "已删除": "Izbrisano",
  "未删除": "Neizbrisano",
  "账号状态": "Status računa",
  "恭喜你，该管理员删除成功": "Čestitamo, administrator je uspješno izbrisan",
  "请输入用户名": "Molimo unesite korisničko ime",
  "修改管理员": "Uredi administratora",
  "添加角色": "Dodaj ulogu",
  "角色ID": "ID uloge",
  "角色名称": "Naziv uloge",
  "恭喜你，该角色删除成功": "Čestitamo, uloga je uspješno izbrisana",
  "编辑角色": "Uredi ulogu",
  "请输入角色名称": "Molimo unesite naziv uloge",
  "权限列表": "Popis ovlasti",
  "请输入用户名和真实姓名": "Molimo unesite korisničko ime i stvarno ime",
  "登录状态": "Stanje prijave",
  "全部标记为已读": "Označi sve kao pročitano",
  "公告详情": "Detalji obavijesti",
  "全部标记为已读消息吗?": "Označiti sve poruke kao pročitane?",
  "操作成功!": "Operacija uspješna!",
  "已取消操作": "Operacija otkazana",
  "订单流程设置": "Postavke procesa narudžbe",
  "已支付订单": "Plaćene narudžbe",
  "分钟后自动核销": "automatsko potvrđivanje nakon minuta",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Ako nije potvrđeno u roku, sustav će automatski potvrditi, postaviti na 0 za ručnu potvrdu",
  "积分商城订单流程设置": "Postavke procesa narudžbe u Trgovini bodovima",
  "已发货订单": "Narudžbe poslane",
  "天后自动核销": "automatska potvrda nakon dana",
  "不包括桌台订单": "bez narudžbe za stolom",
  "恭喜你，交易设置成功": "Čestitamo, postavke transakcije su uspješno primijenjene",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Trenutna verzija",
  "试用版": "Probna verzija",
  "专业版": "Profesionalno izdanje",
  "高级版": "Napredno izdanje",
  "至尊版": "Vrhovno izdanje",
  "到期日期": "Datum isteka",
  "永不过期": "Nikada ne ističe",
  "欢迎您": "Dobrodošli",
  "修改密码": "Promijeni lozinku",
  "此操作将退出登录, 是否继续?": "Ova operacija će vas izlogirati, želite li nastaviti?",
  "原始密码": "Originalna lozinka",
  "新密码": "Nova lozinka",
  "确认新密码": "Potvrdite novu lozinku",
  "系统公告": "Obavijest sustava",
  "请至少选择一件产品商品！": "Molimo odaberite barem jedan proizvod!",
  "超链接设置": "Postavke hiperlinka",
  "图像预览": "Pregled slike",
  "页面": "Stranica",
  "当前链接": "Trenutna veza",
  "暂无": "Nema",
  "页面路径": "Putanja stranice",
  "注意一": "Bilješka jedan",
  "注意二": "Bilješka dva",
  "注意三": "Bilješka tri",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Za isti mini-program koji se povezuje s drugim mini-programima, dopušteno je maksimalno 10 veza; prekoračenje ovog limita ih čini neučinkovitima",
  "不能填写自身小程序appid": "Ne možete upisati appid trenutnog mini programa",
  "小程序链接留空默认跳到小程序首页": "Ako je veza za mini-program prazna, preusmjerava se na početnu stranicu mini-programa",
  "分类": "Kategorija",
  "选择": "Odaberi",
  "签到": "Prijava",
  "积分商城": "Trg s bodovima",
  "秒杀": "Prodaja na kapaljku",
  "拼团": "Kupovina u grupi",
  "砍价": "Pogodba",
  "领券中心": "Centar za kuponiranje",
  "生日有礼": "Rođendanski poklon",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "Povezana web stranica mora podržavati SSL i započeti s https://, inače se neće moći preusmjeriti",
  "链接的域名必须是备案域名，否则无法跳转": "Povezani domenski naziv mora biti registrirani domenski naziv, inače se neće moći preusmjeriti",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Vaša domena web stranice mora biti dodana na poslovnu domenu WeChat Mini Program Public Platform, možete li pružiti više detalja?",
  "选择文章列表": "Odaberi popis članaka",
  "文章标题": "Naslov članka",
  "选择规格": "Odaberi specifikacije",
  "产品/规格": "Proizvod/Specifikacije",
  "已选": "Izabrano",
  "查看物流": "Pogledajte logistiku",
  "请输入收货人": "Molimo unesite primatelja",
  "请输入收获电话": "Unesite broj telefona primatelja",
  "省": "Pokrajina",
  "市": "Grad",
  "区": "Kvart",
  "现金收款": "Plaćanje gotovinom",
  "余额收款": "Plaćanje saldoom",
  "其他方式": "Druge metode",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Unesite ID člana za pretragu člana, zatim kliknite na potvrdi kad završite",
  "请输入会员ID": "Unesite ID člana",
  "会员昵称": "Nadimak člana",
  "余额总计": "Ukupni saldo",
  "登录会员仅作为积分累计，无法享受其他优惠": "Prijavljeni članovi mogu samo sakupljati bodove i ne mogu uživati u drugim popustima",
  "取消收款": "Otkaži plaćanje",
  "收款": "Primi plaćanje",
  "请输入会员手机号": "Unesite broj telefona člana",
  "该用户不存在": "Taj korisnik ne postoji",
  "注册": "Registracija",
  "平台名称": "Naziv platforme",
  "请输入平台名称": "Unesite naziv platforme",
  "所在地区": "Lokacija",
  "请选择所在地区": "Molimo odaberite lokaciju",
  "平台账户名": "Ime platforme",
  "请输入平台账户名": "Unesite ime platforme",
  "平台账户密码": "Lozinka platforme",
  "是否连锁": "Je li u lanac?",
  "请输入您的地址": "Unesite svoju adresu",
  "请输入您的联系电话": "Unesite svoj kontakt telefon",
  "请输入您的联系邮箱": "Unesite svoju kontakt e-poštu",
  "联系邮箱": "Kontaktni e-mail",
  "不能全是空格": "Ne smije biti samo razmaka",
  "不能包含空格": "Ne smije sadržavati razmake",
  "长度不能小于6位": "Duljina ne smije biti manja od 6 znakova",
  "请填写确认密码": "Molimo unesite potvrdnu lozinku",
  "确认密码不一致": "Lozinke se ne podudaraju",
  "联系电话和联系邮箱至少填写一个": "Molimo unesite barem jedan kontakt telefon ili e-adresu",
  "注册成功,请前往登录": "Registracija uspješna, molimo nastavite na prijavu",
  "清空": "Očisti",
  "确认": "Potvrdi",
  "限时免费": "Ograničeno vremenski besplatno",
  // ==================== Components end     =========

  // ==================== 其它  start  ================
  "菜品总量": "Ukupna količina jela",
  "菜品排行榜": "Ljestvica jela",
  "商家信息": "Podaci o trgovini",
  "与店内营业时间相同": "Isto kao radno vrijeme unutar trgovine",
  "菜品": "Jelo",
  "菜品分类": "Kategorizacija jela",
  "添加菜品": "Dodavanje jela",
  "通告": "Obavijest",
  "商家店名": "Naziv trgovine",
  "请输入商家店名": "Molimo unesite naziv trgovine",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "Srdačno upozorenje: Nakon odabira, nemojte nasumično mijenjati kako biste izbjegli nesporazume u podacima o jelima trgovine",
  "网址后缀设置": "Postavke sufiksa URL-a",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "Opciono, postavljanje sufiksa može zamijeniti brojčani ID na kraju sljedećih URL-ova, olakšavajući pamćenje",
  "网址设置": "Postavke URL-a",
  "手机网站二维码": "QR kod mobilne stranice",
  "按菜品收费": "Naplata prema jelima",
  "外卖菜品": "Dostavna jela",
  "店内菜品": "Jela u trgovini",
  "菜品管理": "Upravljanje jelima",
  "菜品名称": "Naziv jela",
  "请输入菜品名称": "Molimo unesite naziv jela",
  "此菜品正在参加活动，不能修改规格": "Ovo jelo sudjeluje u akciji, nije moguće mijenjati specifikacije",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "Kroz tehnologiju umjetne inteligencije, moguće je automatski popuniti detalje o jelima na temelju naziva jela, kao što su sastojci, istaknutost, okus itd.",
  "请填写菜品详情": "Molimo unesite detalje o jelu",
  "菜品详情": "Detalji o jelu",
  "菜品图片": "Slika jela",
  "请上传菜品图片": "Molimo postavite sliku jela",
  "AI未识别到您的菜品图片": "AI nije prepoznao sliku vašeg jela",
  "本菜品正在参加活动，不能删除规格！": "Ovo jelo sudjeluje u aktivnosti, nije moguće izbrisati specifikacije!",
  "菜品加料": "Dodaci za jela",
  "菜品状态": "Status jela",
  "选择菜品状态": "Odabir statusa jela",
  "菜品排序": "Sortiranje jela",
  "请填写菜品名称": "Molimo unesite naziv jela",
  "你选择菜品分类": "Odabrali ste kategoriju jela",
  "菜品卖点": "Istaknutost jela",
  "菜品属性": "Atributi jela",
  "菜品同步": "Sinhronizacija jela",
  "是否同步菜品至外卖": "Sinhronizirati jela za dostavu",
  "是否同步菜品至店内": "Sinhronizirati jela u trgovini",
  "搜索菜品": "Pretraga jela",
  "菜品原价": "Originalna cijena jela",
  "菜品来源": "Izvor jela",
  "菜品列表": "Popis jela",
  "菜品销量": "Prodaja jela",
  "通告管理": "Upravljanje obavijestima",
  "添加通告": "Dodavanje obavijesti",
  "通告ID": "ID obavijesti",
  "通告标题": "Naslov obavijesti",
  "通告分类": "Kategorija obavijesti",
  "通告排序": "Sortiranje obavijesti",
  "通告状态": "Status obavijesti",
  "通告内容": "Sadržaj obavijesti",
  "编辑通告": "Uredi obavijest",
  "AI助理形象选择": "Odabir lika AI asistenta",
  "菜品信息": "Informacije o jelu",
  "菜品总价": "Ukupna cijena jela",
  "请按实际店名填写，将显示在商家点餐网站上": "Molimo unesite stvarni naziv trgovine, prikazat će se na web stranici trgovine za naručivanje hrane",
  "首次添加桌位请先添加桌位类型": "Prvo dodajte tip stola prije dodavanja stolova po prvi put",
  "首次添加桌位请先添加区域": "Prvo dodajte područje prije dodavanja stolova po prvi put",
  "设置店内区域，如A区、B区、大厅、包厢等": "Postavite unutarnje područje, poput Zone A, Zone B, dvorane, sobe itd.",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "Postavite tip stola, poput stola za dvoje, četvoro, velik stol, mali stol itd.",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "Ovaj račun se koristi za prijavu na web stranicu blagajne (adresu blagajne možete pronaći na stranici 'Postavke URL-a')",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "Ovaj račun se koristi za prijavu na web stranicu kuhinje (adresa kuhinje možete pronaći na stranici 'Postavke URL-a')",
  "如无需设置税率可不填写": "Ako ne trebate postaviti poreznu stopu, nemojte je popunjavati",
  "打款信息": "Informacije o plaćanju",
  "开户行": "Banka",
  "菜品分组": "Razvrstavanje jela",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "Prilagođeno ime, koristi se samo za razlikovanje kategorija od strane prodavača i neće biti prikazano kupcima",
  "手机网站编辑": "Uređivanje mobilne web stranice",
  "恢复初始默认页面": "Povratak na početnu stranicu",
  "通告为手机网站上展示的通知、公告、商家介绍等，'显示' 状态时，该篇通告将展示在手机网站上": "Obavijesti na mobilnoj web stranici prikazuju se obavijesti, najave, predstavljanja trgovaca itd. Kada je status 'Prikaži', ta će obavijest biti prikazana na mobilnoj web stranici",
  "菜品重量": "Tečina jela",
  "请填写菜品重量": "Molimo unesite tečinu jela",
  "菜品设置": "Postavke jela",
  "已选择该菜品": "Odabrano je ovo jelo",
  "添加外卖菜品": "Dodavanje jela za dostavu",
  "添加店内菜品": "Dodavanje jela u trgovini",
  "购买指定菜品成为分销商": "Kupite određeno jelo kako biste postali distributer",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "Kupnjom određenog jela i plaćanjem automatski postajete distributer, bez potrebe za provjerom iz pozadine",
  "选择菜品": "Odabir jela",
  "如开启，分销商自己购买菜品，获得一级佣金": "Kada je omogućeno, distributeri sami kupuju jela i zarađuju proviziju prve razine.",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)”": "Iznos plaćanja narudžbe (100,00 €) * Postotak dodjele bodova (100%) = Stvarno dodijeljeni bodovi (100 bodova)",
  "菜品概况": "Pregled jela",
  "菜品统计": "Statistika jela",
  "在售菜品": "Jela na prodaju",
  "已付款菜品": "Plaćena jela",
  "菜品总数": "Ukupan broj jela",
  "已上架菜品": "Postavljena jela",
  "已下架菜品": "Uklonjena jela",
  "菜品导出": "Izvoz jela",
  "菜品总销量": "Ukupna prodaja jela",
  "菜品总销售额": "Ukupan prihod od prodaje jela",
  "菜品ID": "ID jela",
  "菜品编码": "Šifra jela",
  "菜品收藏数": "Broj spremljenih jela",
  "请至少选择一件产品菜品！": "Molimo odaberite barem jedno jelo!",
  "请输入收货电话": "Molimo unesite broj telefona za dostavu",
  "区域管理": "Regionalno Upravljanje",
  "点餐管理系统": "Sustav narudžbe",
  "首页": "Početna",
  "余额支付": "Plaćanje iz ostatka",
  "线下支付(现金支付)": "Offline plaćanje (gotovina)",
  "线下支付(自有微信支付)": "Offline plaćanje (vlastiti WeChat Pay)",
  "线下支付(自有支付宝支付)": "Offline plaćanje (vlastiti Alipay)",
  "线下支付(POS刷卡支付)": "Offline plaćanje (kartično plaćanje na POS uređaju)",
  "待配送": "Za dostavu",
  "配送中": "U isporuci",
  "待接单": "Za prihvaćanje",
  "待取货": "Za preuzimanje",
  "已配送": "Dostavljeno",
  "已收货": "Primljeno",
  "待收货": "Za primanje",
  "待取消": "Za otkazivanje",
  "会员": "Član",
  "商家": "Trgovac",
  "供应商": "Dobavljač",
  "分销": "Distribucija",
  "通知": "Obavijest",
  "已付款": "Plaćeno",
  "用户下单": "Korisnik je napravio narudžbu",
  "收银台下单": "Narudžba na blagajni",
  "扫码下单": "Narudžba skeniranjem koda",
  "团购下单": "Narudžba grupnog kupovanja",
  "商城订单": "Narudžba iz trgovačkog centra",
  "积分商城订单": "Narudžba iz trgovačkog centra s bodovima",
  "余额充值订单": "Narudžba za punjenje salda",
  "购卡订单": "Narudžba za kupnju kartice",
  "券包订单": "Narudžba za paket kupona",
  "配送员押金订单": "Narudžba za polaganje kaucije dostavljača",
  "快递配送": "Brza dostava",
  "个人中心": "Osobni centar",
  "在地图中点击确认位置，坐标自动填入":"Kliknite da biste potvrdili lokaciju na karti, a koordinate će se automatski popuniti.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Za dodavanje kupona, molimo vas idite na 'Marketing' - 'Marketinški alati' - 'Kupon'.",
  // ==================== 其它  end    ================

  ...hrLocale
}


export default hr



// WEBPACK FOOTER //
// ./src/i18n/langs/hr.js